define('home/views/NotificationCardHighlightPostView',[
    'home/views/common/NotificationCardPostView',
    'home/templates/notificationCardHighlightPost',
], function (
    NotificationCardPostView,
    notificationCardHighlightPostTemplate
) {
    'use strict';

    var parent = NotificationCardPostView;

    var NotificationCardHighlightPostView = parent.extend({
        // See NotificationCardHighlightPostView.className for documentation
        childClassName: 'card-notif-highlight',

        template: notificationCardHighlightPostTemplate,

        getPost: function (activity) {
            return activity.target;
        },
    });

    return NotificationCardHighlightPostView;
});

